import React, { useState, useCallback } from "react";
import {
	SettingToggle,
	TextStyle,
	Card,
	Banner,
	Modal,
	Link,
} from "@shopify/polaris";
import callApi from "../../utils/apiCaller";
import { useSelector, useDispatch } from "react-redux";
import { actFetchDataSettings } from "../../actions/index";
import config from "../../config/config";
import { NotificationMajor } from "@shopify/polaris-icons";
import Swal from "sweetalert2";
import PlanTable from "../Dashboard/PlanTable";
import Example from "../../assets/example.png";
import Example2 from "../../assets/example_2.png";
const SaveDataOrderNote = () => {
	const dispatch = useDispatch();
	const [modalPlan, setModalPlan] = useState(false);
	const [modalScope, setModalScope] = useState(false);
	const [showExample, setShowExample] = useState(false);
	const dataSettings = useSelector((state) => state.dataSettings);

	const handleToggle = useCallback(() => {
		if (config.role !== "view") {
			if (dataSettings.plan == "free" || dataSettings.plan == "basic") {
				Swal.fire({
					icon: "warning",
					title: "Need to upgrade Plan!",
					html: "This function is only available when using <b>Pro plan or higher</b>",
					showCancelButton: true,
					confirmButtonText: "Pick a higher Plan",
					showConfirmButton: true,
				}).then((result) => {
					if (result.value) {
						setModalPlan(true);
					}
				});
			} else {
				if (dataSettings.write_order_scope === "0") {
					Swal.fire({
						icon: "warning",
						title: "Need more scopes!",
						html: "To use this feature, we need additional permission to edit your order information.",
						showCancelButton: true,
						confirmButtonText: "Grant more scopes",
						showConfirmButton: true,
					}).then((result) => {
						console.log(config);
						if (result.value) {
							let redirectUri =
								config.rootLink +
								"get_code.php?status=update_scope";
							let confirmationUrl =
								"https://" +
								config.shop +
								"/admin/oauth/authorize?client_id=" +
								config.apiKey +
								"&redirect_uri=" +
								redirectUri +
								"&scope=read_orders,read_all_orders,write_orders";
							window.top.location.replace(confirmationUrl);
						}
					});
				} else {
					let newStatus =
						dataSettings.save_data_to_order_note === "0"
							? "1"
							: "0";
					let params = {
						action: "updateSaveDataSyncToShopify",
						status: newStatus,
					};
					callApi("get", params, "services.php").then(function (
						response
					) {
						if (response.data.state === 1) {
							let newDataSettings = { ...dataSettings };
							newDataSettings.save_data_to_order_note = newStatus;
							dispatch(actFetchDataSettings(newDataSettings));
						}
					});

					let newDataSettings = { ...dataSettings };
					newDataSettings.save_data_to_order_note = dispatch(
						actFetchDataSettings(newDataSettings)
					);
				}
			}
		}
	}, [dataSettings, dispatch]);

	const contentStatus =
		dataSettings.save_data_to_order_note === "1" ? "Turn off" : "Turn on";
	const textStatus =
		dataSettings.save_data_to_order_note === "1" ? "ON" : "OFF";

	return (
		<div style={{ marginTop: "20px" }} className="notify buyer-page">
			<Banner
				status="success"
				icon={NotificationMajor}
				title="Display synced information on Shopify order notes"
			>
				<div className="mt-1">
					<SettingToggle
						action={{
							content: contentStatus,
							onAction: handleToggle,
						}}
						enabled={
							dataSettings.save_data_to_order_note === "0"
								? false
								: true
						}
					>
						After activating the function, the synchronized
						information of the next orders will be displayed as a
						note on your Shopify order tab. Current status: {""}
						<TextStyle variation="strong">{textStatus}</TextStyle>
					</SettingToggle>
				</div>
			</Banner>
			<div className="mt-4">
				{/* <Link
          url="https://help.omegatheme.com/en/article/synctrack-new-feature-sync-info-to-shopify-order-note-available-for-pro-and-above-plan-1sp2f6y/"
          external
        >
          View document
        </Link>
        {" - "} */}
				<Link onClick={() => setShowExample(!showExample)}>
					View example
				</Link>{" "}
			</div>
			{showExample ? (
				<div>
					<img className="w-100 mt-4" src={Example} />
					<img className="w-100 mt-4" src={Example2} />
				</div>
			) : null}
			<Modal
				large={true}
				open={modalPlan}
				onClose={() => setModalPlan(false)}
				title="Pricing Table"
				secondaryActions={[
					{
						content: "Cancel",
						onAction: () => setModalPlan(false),
					},
				]}
			>
				<Modal.Section>
					<PlanTable type="step" />
				</Modal.Section>
			</Modal>
		</div>
	);
};

export default SaveDataOrderNote;
